import dayjs from 'dayjs';
import { useSelector } from '@betty/toolkit/state';
import { selectCommunityJackpotEvents } from '../state';

export const useVisibilityChecker = () => {
  const [eventData] = useSelector(selectCommunityJackpotEvents);

  const currentDate = new Date();
  const startDate = new Date(eventData?.startDate);
  const endDate = new Date(eventData?.endDate);

  const showUntilDate = eventData?.showUntil
    ? dayjs(eventData.showUntil).toDate()
    : dayjs(endDate).add(3, 'day').toDate();

  const showCampaign = startDate <= currentDate && currentDate <= showUntilDate;

  return showCampaign;
};
